import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgAngleLeftSmall } from './svg/angle-left-small.svg.js';

/**
 * @deprecated - use ArrowAngleLeft.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
const AngleLeftSmall = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, size: _size, legacyBoundingBox: _legacyBoundingBox, ...rest } = props;
    return (jsx(SvgAngleLeftSmall, { viewBox: "-6 -6 36 36", "aria-label": title, role: "img", ...rest, width: 24, height: 24, "data-pp-icon": "AngleLeftSmall" }));
};

export { AngleLeftSmall as default };
//# sourceMappingURL=AngleLeftSmall.js.map
